/**
 * Якорь вопроса на странице /faq: `#q-<id>`.
 *
 * Отдельный модуль без зависимостей намеренно: его берёт клиентский аккордеон,
 * а lib/faq/markdown.ts тянет react-markdown — импорт оттуда увёз бы парсер
 * в браузерный бандл.
 *
 * id вопроса — uuid из faq_items. Всё, что на uuid не похоже, якорем вопроса
 * не считается: и `#payment` из текста ответа, и мусор в адресе.
 */

export const FAQ_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const HASH_PREFIX = '#q-';

/**
 * Адрес ссылки на вопрос. Элемента с id `q-<id>` на странице нет намеренно —
 * карточку ищут по атрибуту (lib/faq/reveal.ts), иначе браузер прыгал бы к ней сам
 */
export function questionHash(id: string): string {
  return `${HASH_PREFIX}${id}`;
}

/** `#q-<uuid>` → uuid в нижнем регистре; что угодно другое → null */
export function questionIdFromHash(hash: string | null | undefined): string | null {
  if (typeof hash !== 'string' || !hash.startsWith(HASH_PREFIX)) return null;
  const id = hash.slice(HASH_PREFIX.length);
  return FAQ_UUID.test(id) ? id.toLowerCase() : null;
}
